// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.csfirstCol {
    text-align: left;
}

.csSecCol {
    text-align: center;
}

.csDataRow {
    line-height: 1.4;
}

.clusterSliderTB {
    width: 75px;
}`, "",{"version":3,"sources":["webpack://./src/app/workflow/modules/dataoperations/ai/multianomalydetection/multi.anomaly.detection.settings.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".csfirstCol {\n    text-align: left;\n}\n\n.csSecCol {\n    text-align: center;\n}\n\n.csDataRow {\n    line-height: 1.4;\n}\n\n.clusterSliderTB {\n    width: 75px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
